import { IStackItemStyles, IStyle, mergeStyles } from "@fluentui/react";

export const activeElementAndLocalPreviewTileStyles: IStackItemStyles = {
    root: {
        alignSelf: "stretch",
        overflow: "hidden",     //otherwise "height: 100%" of nested elements would not work.
        flex: 1,                //defines height of the element
    },
};

export const horizontalContainerStyles = {
    root: mergeStyles(
        {
            display: "flex",
            flexDirection: "row",
            maxHeight: "100%",  //defines width by the '32 / 9' aspect-ratio for wide screen.
            height: "auto",
            aspectRatio: "32 / 9", //== two containers with aspect-ratio: "16 / 9"
            alignSelf: "stretch",   // makes width: "100%". The width defines height by '32 / 9' aspect-ratio for narrow screen.
            width: "100%",
        } as IStyle
    ),
    localPreviewTile: mergeStyles(
        {
            flex: 1,
            maxWidth: '50%',
        } as IStyle
    ),
    activeElement: mergeStyles(
        {
            flex: 2,
            display: "flex",
            justifyContent: "center",
            minWidth: '50%',
        } as IStyle
    )
}
